import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import store from "@/store/index";
import CONF from '@/config';
import { logout } from '@/_oad_repo/auth';
import { utils } from '@/_oad_repo/utils';
import router from '../../routes';

Vue.use(VueAxios, axios)

window.axios = require('axios');
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.withCredentials = true;
axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.accessToken;
axios.defaults.baseURL = CONF.API_URL

axios.interceptors.request.use((config) => {
  if (store.state.expiration && !config.url.includes('/logout') && !config.url.includes('/login')) {
    const expiration_date = new Date(store.state.expiration)
    const now = new Date(Date.now())
    let diff = (expiration_date.getTime() - now.getTime()) / 1000
    diff /= 60
    if (diff < 1) {
      return Promise.reject({ response: { status: 401 } });
    }
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});



axios.interceptors.response.use(
    res => {
        //removing debug property from responses.
        if (typeof res.data !== 'undefined' && typeof res.data.debug !== 'undefined') 
            delete res.data.debug;

        if (res.status < 400 && res.status != 251) {
            return res;
        } else if (res.status == 251) { //permission managment
            utils.c_notify(res.data.msg, res.data.status);
            return false;
        }
    }, 
    error => {
        if (error && error.response) {
            if (error.response.status >= 500) {
                let message = (error.response && error.response.data && error.response.data.message) ? error.response.data.message : 'System Error'
                utils.c_notify(message, 'error');
            } else if (error.response.status = 401) {
                store.commit('resetStorage','');
                if (store.state.showSesExp) {
                    utils.c_notify('Session Expired', 'error');
                    store.commit('setShowSesExp', false);
                }
                if (router.currentRoute.name !== 'login') {
                    store.commit('setRedirectUrl', router.history._startLocation)
                    router.push({ name: 'login' })
                }
                return false;
            }
        }

    }
  );